module.exports = __webpack_public_path__ + "static/media/java3.6fa3c42c.png";